module.exports = __webpack_public_path__ + "media/components/documents/images/taxReturnForms/1040-7e74a4ee81868565155420391c172c62.png";